import { parseUnits } from 'viem';

import { truncateAmountToDecimals } from '@/app/shared/lib/formatters';

export const safeParseUnits = (
  value?: string,
  decimals?: number
): bigint | undefined => {
  if (!value || decimals === undefined) return undefined;
  if (isNaN(Number(value))) return undefined;

  try {
    const truncated = truncateAmountToDecimals(value, decimals);
    return parseUnits(truncated, decimals);
  } catch {
    return undefined;
  }
};
